module.exports = __webpack_public_path__ + "img/badge_economy_simple.db3f3807.png";